import { render, staticRenderFns } from "./OrderConfirmationBodyPayment.vue?vue&type=template&id=747bcc1b&"
import script from "./OrderConfirmationBodyPayment.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationBodyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports